import AuthService from '../services/auth-service';

const header = {
	/**
	 * Controla abertura do menu
	 */
	controlMenu: () => {
		// document.querySelectorAll('.act-open-menu-itens').forEach(container => {
		//   container.addEventListener('click', e => {
		//     if (document.getElementById(`cloned-div`)) document.getElementById(`cloned-div`).remove()
		//     if (window.innerWidth < 1024) {
		//       const cloned = document.querySelector(`[data-menu-itens=${e.target.dataset.menu}]`).cloneNode(true)
		//       cloned.setAttribute('id', 'cloned-div')
		//       document.getElementById(`column-${e.target.dataset.after}`).appendChild(cloned)
		//     } else {
		//       document.querySelectorAll(`[data-menu-itens]`).forEach(item => {
		//         item.classList.remove('_block')
		//       })
		//       document.querySelector(`[data-wrapper-menu-itens]`).classList.add('_block')
		//       document.querySelector(`[data-menu-itens=${e.target.dataset.menu}]`).classList.add('_block')
		//     }
		//   })
		// })
		// document.getElementById('hamburguer-menu').addEventListener('click', e => {
		//   if (window.innerWidth < 1024) {
		//     document.body.classList.toggle('_overflow-hidden')
		//   }
		// })
	},

	/**
	 * Controla logout
	 */
	controlLogout: () => {
		document.addEventListener('click', e => {
			const logoutBtn = e.target.closest('.act-logout');
			if (logoutBtn) {
				e.preventDefault();
				AuthService.logout();
			}
		});
	},

	init: () => {
		header.controlMenu();
		header.controlLogout();
	},
};

header.init();

export default header;
